import React from "react";
import ViewMoreText from "../../../../../CommonComponents/ViewMore/ViewMore";
import { Skeleton } from "antd";
import "./TicketDetails.css";

const EventSummary = ({ isLoading = true, summaryData, eventDescription }) => {
  return (
    <div className="event-summary-card">
      <div style={{ marginBottom: "12px" }}>
        <h6
          style={{
            fontWeight: "600",
            fontSize: "16px",
            color: "#262626",
          }}
        >
          Event Summary
        </h6>
      </div>

      <div style={{ marginBottom: "12px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
            gap: "12px",
          }}
        >
          {isLoading
            ? Array.from({ length: 6 }).map((_, index) => (
                <div key={index}>
                  <div style={{ marginBottom: "8px" }}>
                    <Skeleton.Input
                      active
                      size="small"
                      style={{ width: "90px", height: "16px" }}
                    />
                  </div>
                </div>
              ))
            : summaryData.map((item, index) => (
                <div key={index}>
                  <div
                    className="summary-item"
                    style={{
                      marginBottom: "4px",
                    }}
                  >
                    <div className="summary-item-label">{item.label}</div>
                    <div
                      style={{
                        fontWeight: "600",
                        color: "#262626",
                        fontSize: "14px",
                      }}
                    >
                      {item.value}
                    </div>
                  </div>
                </div>
              ))}
        </div>

        <div>
          {isLoading ? (
            <div>
              <Skeleton
                active
                paragraph={{ rows: 1, width: ["75%"] }}
                title={false}
                style={{ marginTop: "8px" }}
              />
            </div>
          ) : (
            eventDescription && (
              <div>
                <div
                  style={{
                    fontWeight: "500",
                    color: "#8c8c8c",
                    fontSize: "12px",
                    marginBottom: "4px",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginTop: "12px",
                  }}
                >
                  Event Description
                </div>
                <div
                  style={{
                    fontWeight: "600",
                    color: "#262626",
                    fontSize: "14px",
                  }}
                >
                  <ViewMoreText text={eventDescription} maxLength={150} />
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default EventSummary;
